module.exports = __webpack_public_path__ + "static/media/logo-amazon-video.c4373db7.png";